import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-tiles',
  templateUrl: './test-tiles.component.html',
  styleUrls: ['./test-tiles.component.css']
})
export class TestTilesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
